// Library Imports
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// Local Imports
import { useIsAuthenticatedUser } from '@/utils';
import { ROUTE_PATHS } from '@/router/constants';

const PrivateRoutes = () => {
    const isAuthenticated = useIsAuthenticatedUser();
    
    if (!isAuthenticated) {
        return <Navigate to={ROUTE_PATHS.LOGIN} replace />;
    }
    
    return (
        <Suspense>
            <Outlet />
        </Suspense>
    );
}

export default PrivateRoutes